import { createTheme } from "@mui/material";


let theme = createTheme({
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        p: {
          fontWeight:500
        },
        label: {
          color: "#171717",
        }
      }
    }
  },
    typography: {
        allVariants: {
          fontFamily: "'Montserrat', san-serif",
          textTransform: 'none',
          fontWeight: 500,
          fontSize: 14,
          lineHeight: "19px",
          color: "#171717",
          letterSpacing: "0.2px",
        },
      },
})

export default theme